import { render, staticRenderFns } from "./Shots.vue?vue&type=template&id=71f37404&scoped=true&"
import script from "./Shots.vue?vue&type=script&lang=js&"
export * from "./Shots.vue?vue&type=script&lang=js&"
import style0 from "./Shots.vue?vue&type=style&index=0&id=71f37404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f37404",
  null
  
)

export default component.exports